<div
  class="card h-100 d-inline-block d-flex flex-column bg-light"
  [class.step2]="!!highlighted"
>
  <div class="row h-25" *ngIf="imageUri">
    <img
      *ngIf="!!completed"
      class="check-mark w-auto px-0"
      src="/assets/images/home/check-mark-icon.svg"
      alt="checkmark"
    />
    <div class="col-12">
      <div class="card-image-wrapper">
        <img
          *ngIf="imageUri"
          [class.step2-icon]="!!highlighted"
          [src]="imageUri"
          alt="step_card_image"
        />
      </div>
    </div>
  </div>
  <div class="row h-75 pt-3">
    <div class="col-12">
      <div class="card-body">
        <h3 class="card-title-text"><b>{{ title }}</b></h3>
        <h4 class="card-title-text">{{ subtitle }}</h4>
        <p class="card-body-text mb-3">{{ body }}</p>
        <div class="mb-3" *ngIf="!!buttonUri">
          <a class="card-link" [routerLink]="buttonUri">
            {{ buttonLabel }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
